'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _Media = require('./Media.css');

var _Media2 = _interopRequireDefault(_Media);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _reactPlayer = require('react-player');

var _reactPlayer2 = _interopRequireDefault(_reactPlayer);

var _reactSlidedown = require('react-slidedown');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Media = (_dec = (0, _reactCssModules2.default)(_Media2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Media, _Component);

  function Media(props) {
    (0, _classCallCheck3.default)(this, Media);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Media.__proto__ || (0, _getPrototypeOf2.default)(Media)).call(this, props));

    _this.pressHits = [{
      outlet: 'Marketplace',
      headline: 'Looking at wealth management through a "gender lens"',
      link: 'https://www.marketplace.org/2019/01/09/your-money/more-investment-firms-investors-are-applying-gender-lens-wealth-building'
    }, {
      outlet: 'Quartz',
      headline: 'This tool is an easy way to check if your investments support gender equality',
      link: 'https://qz.com/1461617/as-you-sow-checks-how-well-mutual-funds-promote-gender-equality/'
    }, {
      outlet: "Barron's",
      headline: 'Just How Gender-Equity Focused Is That Fund, Anyway?',
      link: 'https://www.barrons.com/articles/just-how-gender-equity-focused-is-that-fund-anyway-1542126101'
    }, {
      outlet: 'Fast Company',
      headline: 'This tool helps you make sure your 401(k) is supporting gender equality',
      link: 'https://www.fastcompany.com/90263635/this-tool-helps-you-make-sure-your-401k-is-supporting-gender-equality'
    }, {
      outlet: 'U.S. News and World Report',
      headline: 'How to Find Gender Equality Mutual Funds and ETFs',
      link: 'https://money.usnews.com/investing/funds/articles/how-to-find-gender-equality-mutual-funds-and-etfs'
    }, {
      outlet: 'Financial Advisor Magazine',
      headline: 'New Tool Applies Gender Diversity Screen To Mutual Fund, ETF Holdings',
      link: 'https://www.fa-mag.com/news/a-gender-lens-now-can-be-applied-to-investments-41832.html'
    }];

    _this.clickViewMore = function (release) {
      var newState = {};
      newState[release] = !_this.state[release];
      _this.setState(newState);
    };

    _this.renderReleaseLaunch = function () {
      return _react2.default.createElement(
        'div',
        { styleName: 'release-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'press-release-title' },
          'New Gender Lens Investing Tool Helps Drive Capital to Mutual Funds Supporting Gender Equality'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            'As You Sow is gearing up to release its fifth Invest Your Values screening tool, Gender Equality Funds'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            'Oakland, California \u2014 Nov. 13 2018 \u2014'
          ),
          ' As You Sow is gearing up to release its fifth Invest Your Values screening tool, Gender Equality Funds, on Nov. 13. Gender Equality Funds is a free, online tool that enables individual and institutional investors to apply a gender lens to mutual fund and ETF investments.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Gender Equality Funds screens the specific holdings of about 5,000 of the most commonly-held U.S. mutual funds\u2014including financial giants like Vanguard, BlackRock, and State Street\u2014against a database detailing individual company performance on 12 key gender equality performance indicators. These 12 indicators measure policies that demonstrate a commitment to gender diversity and gender balance in the overall leadership, management, and workforce of companies, combining into an overall gender equality portfolio score for each mutual fund.'
        ),
        _react2.default.createElement(
          _reactSlidedown.SlideDown,
          null,
          _this.state.releaseLaunch ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'This transparency gives investors, for the first time, the ability to apply a gender lens in evaluating mutual funds. It encourages fund managers to construct and offer investment vehicles that are sympathetic to gender parity, ultimately exerting market pressure on companies to improve their performance on gender issues.'
            ),
            _react2.default.createElement(
              'p',
              null,
              '\u201CThis tool could not be coming out at a better time,\u201D Andrew Behar, CEO of As You Sow, said. \u201CWomen comprise 47 percent of the workforce, but only 4.8 percent of S&P 500 companies have female CEOs. The new tool empowers investors to see what is hidden within the mutual funds that comprise the bulk of their retirement savings and 401(k) plans. The first step is to know what you own \u2014 then you can use the power of your capital to invest in companies that have policies and practices that promote gender equality. We expect this tool to unleash a tsunami of change in the way women are treated in the workforce.\u201D'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Gender Equality Funds enables investors to align their investment with their values. It reveals which mutual funds are investing in the companies that lead the field in terms of gender balance and equality. Investors can easily search the Gender Equality Funds database to see how specific funds are scored, find responsible options that track leading companies in terms of gender equality, and compare financial returns.'
            ),
            _react2.default.createElement(
              'p',
              null,
              '\u201CI am thrilled to see As You Sow launching this gender lens tool,\u201D Kristin Hull, founder and CEO of Nia Impact Capital, said. \u201CWe at Nia know the benefit to companies and investors of being gender smart. My hope is that advisors and investors across the country will utilize this new way to assess mutual funds.\u201D'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Gender Equality Funds sources mutual fund holdings data from Morningstar and company-specific gender data from Equileap, the leading organization providing data and insights on gender equality in the corporate sector. With Gender Equality Funds, you\u2019ll see at a glance whether mutual funds are investing in companies that are prioritizing gender equality.'
            ),
            _react2.default.createElement(
              'p',
              null,
              '\u201CImpact investing should not be limited to private deals or customized public portfolios,\u201D Ruth Shaber, founder and president of Tara Health Foundation, said. \u201CThe bulk of the wealth in this country is invested in mutual funds. If we want to democratize access to impact investing, we need to create tools for everyone, from individuals with 401(k)s to institutional investors with billions of dollars under management. The Gender Equality Funds tool allows anyone to apply a gender lens to their investments.\u201D'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Gender Equality Funds is As You Sow\u2019s fifth Invest Your Values online tool, joining Fossil Free Funds, Deforestation Free Funds, Tobacco Free Funds, and Weapon Free Funds.'
            )
          ) : null
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'release-btn-cntr' },
          _react2.default.createElement(
            'button',
            {
              styleName: 'release-btn',
              onClick: function onClick() {
                return _this.clickViewMore('releaseLaunch');
              }
            },
            _this.state.releaseLaunch ? _react2.default.createElement(
              'span',
              null,
              'Show less',
              _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-angle-up' })
            ) : _react2.default.createElement(
              'span',
              null,
              'Show more',
              _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-angle-down' })
            )
          )
        )
      );
    };

    _this.state = {
      releaseLaunch: false
    };
    return _this;
  }

  (0, _createClass3.default)(Media, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var title = 'Media';
      var description = '';
      var url = _config2.default.domain + _config2.default.routes.media;

      return _react2.default.createElement(
        'div',
        null,
        _container2.default.helmet(title, description, url),
        _react2.default.createElement(
          'div',
          { styleName: 'page' },
          _react2.default.createElement(
            'div',
            { styleName: 'container' },
            _react2.default.createElement(
              'div',
              { styleName: 'container-inner' },
              _react2.default.createElement('div', { styleName: 'anchor', id: 'top' }),
              _react2.default.createElement(
                'div',
                { styleName: 'title' },
                title
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answers' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'answer' },
                  _react2.default.createElement('div', { styleName: 'anchor', id: 'contact' }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'answer-title' },
                    'Get in touch \xA0\u2014\xA0',
                    _react2.default.createElement(
                      _components.Link,
                      {
                        xstrong: true,
                        styleName: 'contact',
                        to: _config2.default.links.contact,
                        title: 'Contact form' },
                      'Contact us',
                      _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-envelope-o' })
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'answer webinar-answer' },
                  _react2.default.createElement('div', { styleName: 'anchor', id: 'webinar' }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'answer-title' },
                    'Webinar video'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'media-react-player-wrap' },
                    _react2.default.createElement(_reactPlayer2.default, {
                      url: 'https://vimeo.com/302518828',
                      volume: 0.5
                    })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'answer' },
                  _react2.default.createElement('div', { styleName: 'anchor', id: 'release' }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'answer-title' },
                    'Press release'
                  ),
                  this.renderReleaseLaunch()
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'answer' },
                  _react2.default.createElement('div', { styleName: 'anchor', id: 'press' }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'answer-title' },
                    'Media coverage'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'answer-info' },
                    this.pressHits.map(function (pressHit, i) {
                      return _react2.default.createElement(
                        'div',
                        { key: i, styleName: 'press-item' },
                        _react2.default.createElement(
                          _components.Link,
                          {
                            to: pressHit.link,
                            title: pressHit.outlet + ' - ' + pressHit.headline },
                          _react2.default.createElement(
                            'div',
                            { styleName: 'press-item-outlet' },
                            pressHit.outlet
                          ),
                          _react2.default.createElement(
                            'div',
                            null,
                            pressHit.headline,
                            _react2.default.createElement(_components.LinkIcon, null)
                          )
                        )
                      );
                    })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'answer' },
                  _react2.default.createElement('div', { styleName: 'anchor', id: 'contact' }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'answer-title' },
                    'Media + General inquiries'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'answer-info' },
                    _react2.default.createElement(
                      'p',
                      null,
                      _react2.default.createElement(
                        'strong',
                        null,
                        'Media'
                      )
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      'Stefanie Spear, Communications Director, Gender Equality Funds'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      _react2.default.createElement(
                        _components.Link,
                        {
                          xstrong: true,
                          styleName: 'contact',
                          to: _config2.default.links.contactStefanie,
                          title: 'Email Stefanie Spear, Communications Director, Gender Equality Funds' },
                        'Email',
                        _react2.default.createElement(_components.LinkIcon, null)
                      )
                    ),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                      'p',
                      null,
                      _react2.default.createElement(
                        'strong',
                        null,
                        'General'
                      )
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      'Andrew Montes, Director of Digital Strategies, As You Sow'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      _react2.default.createElement(
                        _components.Link,
                        {
                          xstrong: true,
                          styleName: 'contact',
                          to: _config2.default.links.contactAndrew,
                          title: 'Email Andrew Montes, Director of Digital Strategies, As You Sow  ' },
                        'Email',
                        _react2.default.createElement(_components.LinkIcon, null)
                      )
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(_components.GetStartedInput, null)
        )
      );
    }
  }]);
  return Media;
}(_react.Component)) || _class);
exports.default = Media;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Media/Media.js
// module id = 1310
// module chunks = 0